import React, { useState, useEffect, useCallback } from 'react';
import CrystalPuzzle from './components/CrystalPuzzle';
import Leaderboard from './components/Leaderboard';
import ThemeToggle from './components/ThemeToggle';
import { getThemeColors } from './constants/colors';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { apiClient } from './utils/api';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    return localStorage.getItem('theme') === 'dark';
  });
  const [currentUserId, setCurrentUserId] = useState(null);

  const theme = getThemeColors(isDarkMode);

  const handleThemeToggle = useCallback((newValue) => {
    // If called with a boolean directly (e.g., from login), use it; otherwise toggle
    if (typeof newValue === 'boolean') {
      setIsDarkMode(newValue);
    } else {
      setIsDarkMode(prev => !prev);
    }
  }, []);

  // Save theme preference to DB whenever it changes and user is logged in
  useEffect(() => {
    if (apiClient.isAuthenticated()) {
      apiClient.updateThemePreference({ isDarkMode }).catch(err => {
        console.error('Failed to save theme preference:', err);
      });
    }
  }, [isDarkMode]);

  const handleUserChange = (userId) => {
    setCurrentUserId(userId);
  };

  useEffect(() => {
    console.log('Theme changed to:', isDarkMode ? 'dark' : 'light');
    
    const root = document.documentElement;
    if (isDarkMode) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDarkMode]);


  return (
    <WebSocketProvider>
      <div className={`min-h-screen ${theme.background}`}>
        <header className={`shadow-sm ${theme.header}`}>
          <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between">
              <h1 className={`text-2xl font-semibold ${theme.text}`}>
                Tubes
              </h1>
              <ThemeToggle 
                isDarkMode={isDarkMode} 
                onToggle={handleThemeToggle}
              />
            </div>
            <div className="mt-4">
              <Leaderboard 
                theme={theme} 
                isDarkMode={isDarkMode} 
                userId={currentUserId}
              />
            </div>
          </div>
        </header>

        <main className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
          <div className={`rounded-lg shadow-xl p-6 ${theme.container}`}>
            <CrystalPuzzle 
              parentIsDarkMode={isDarkMode}
              onThemeChange={handleThemeToggle}
              onUserChange={handleUserChange}
              theme={theme}
            />
          </div>
        </main>

        <footer className={`${theme.header} mt-auto`}>
          <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
            <p className={`text-center text-sm ${theme.subtext}`}>
              © {new Date().getFullYear()} Tubes - All rights reserved
            </p>
          </div>
        </footer>

      </div>
    </WebSocketProvider>
  );
}

export default App;
